import type { SVGProps } from "react";
export interface Rocket02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Rocket02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Rocket02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M9.228 4.845C13.604.79 18.078.672 20.383.983l.255.046a3.05 3.05 0 0 1 2.379 2.588c.311 2.306.192 6.78-3.863 11.155l.06.18.101.343a5.07 5.07 0 0 1-1.324 4.84l-1.516 1.516a1.62 1.62 0 0 1-2.624-.486l-.076-.213-.795-2.78a1.61 1.61 0 0 1-1.724-.36l-5.07-5.067a1.62 1.62 0 0 1-.36-1.729l-2.778-.792a1.617 1.617 0 0 1-.699-2.699L3.866 6.01l.262-.244a5.07 5.07 0 0 1 4.92-.98zm10.853-1.632c-1.901-.257-5.861-.197-9.769 3.71a1.13 1.13 0 0 1-1.151.271l-.825-.274a2.81 2.81 0 0 0-2.88.68l-.757.756 3.037.867a1.127 1.127 0 0 1 .697 1.585l-.334.667 4.424 4.423.668-.332.115-.049a1.125 1.125 0 0 1 1.47.746l.867 3.037.757-.756.135-.147c.605-.697.83-1.648.6-2.543l-.055-.19-.274-.825c-.135-.404-.03-.85.271-1.151 3.663-3.663 3.945-7.373 3.754-9.39l-.044-.38a.8.8 0 0 0-.706-.705"
      />
      <path
        fill={color}
        d="M2.378 16.912c.977-2.32 4.028-2.951 5.844-1.135l.169.18c1.605 1.832.94 4.719-1.304 5.665l-.228.087-3.827 1.326c-1.281.444-2.51-.787-2.066-2.068l1.324-3.825zm4.254.456c-.7-.7-1.893-.426-2.217.51l-.904 2.608 2.61-.902a1.342 1.342 0 0 0 .63-2.079l-.12-.137Zm9.335-11.233a2.126 2.126 0 0 1-.217 4.24c-1.1 0-2.005-.836-2.114-1.908l-.011-.217.011-.218a2.125 2.125 0 0 1 2.114-1.907z"
      />
    </svg>
  );
}
